/* ----------------------------------------
    Imports
---------------------------------------- */

import { ApiService } from './ApiService';

/* ----------------------------------------
    API Service
---------------------------------------- */

export class ProjectService extends ApiService {

    /* ----------------------------------------
        Constructor
    ---------------------------------------- */

    protected constructor(store) {
        super('', store);
    }

    public async getProjectList() {
        return this.get(`/user/projects/`);
    }

    public async postProject(data: [object]) {
        return this.post('/project', data);
    }

    public async getProject(id: string = '') {
        return this.get(`/project/${ id }`);
    }

    public async deleteProject(id: string = '') {
        return this.delete(`/project/${ id }`);
    }

    public async putProject(id: string = '', data: object = {}) {
        return this.put(`/project/${ id }`, data);
    }

    public async submitProject(id: string = '', data: object = {}) {
        return this.post(`/project/${ id }/submit`, data);
    }

    public async postNote(id: string = '', data: object = {}) {
        return this.post(`/project/${ id }/note`, data);
    }

    public async getPlanDataRows(projectId: string = '', type: string = '') {
        return this.get(`/project/${projectId}/plan-data/${type}`);
    }

    public async addPlanDataRow(projectId: string = '', type: string = '', data: object = {}) {
        return this.post(`/project/${projectId}/plan-data/${type}`, data);
    }

    public async updatePlanDataRow(projectId: string = '', type: string = '', planDataId: string = '', data: object = {}) {
        return this.put(`/project/${projectId}/plan-data/${type}/${planDataId}`, data);
    }

    public async deletePlanDataRow(projectId: string = '', type: string = '', planDataId: string = '') {
        return this.delete(`/project/${projectId}/plan-data/${type}/${planDataId}`);
    }

    public async createPlanFile(projectId: string = '') {
        return this.post(`/project/${projectId}/plan-data/create-file`);
    }

    public async deletePlanFile(projectId: string = '') {
        return this.delete(`/project/${projectId}/plan-data/delete-file`);
    }
}
